/**
 * @starkwang
 * 花样PC整合项目
 * 窗口标题栏
 */

import React, { Component } from 'react'
import defaults from 'lodash.defaults'
import PropTypes from 'prop-types'
import { DragWindow, Minimize, Close } from '@tencent/hymixed-pcapi'
import IconClose from '../icon/close/index.js'
import IconSubtract from '../icon/subtract/index.js'
import './index.less'

// JSDoc 注释， 解决React Component默认类型的问题
/** @augments {Component<object, object>} */
export default class Header extends Component {
    constructor(props, context) {
        super(props, context)
    }

    componentDidMount() {}

    dragWindow(e) {
        if (e && e.target && e.target.className === 'hypc-title-bar') {
            DragWindow()
        }
    }

    minimizeWindow() {
        Minimize()
    }

    closeWindow() {
        Close()
    }

    render() {
        const { title, subtitle, minimizeButton, closeButton } = defaults(
            { ...this.props },
            {
                title: '标题栏',
                subtitle: '',
                minimizeButton: false,
                closeButton: true
            }
        )
        return (
            <div className="hypc-title-bar" onMouseDown={this.dragWindow}>
                <p className="hypc-title-bar-text">{title}</p>
                <p className="hypc-title-bar-subtext">{subtitle}</p>

                {closeButton && (
                    <div className="hypc-title-bar-button hypc-title-bar-button-close" onClick={this.closeWindow}>
                        <IconClose />
                    </div>
                )}
                {minimizeButton && (
                    <div className="hypc-title-bar-button hypc-title-bar-button-mini" onClick={this.minimizeWindow}>
                        <IconSubtract />
                    </div>
                )}
            </div>
        )
    }
}

Header.PropTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    minimizeButton: PropTypes.bool,
    closeButton: PropTypes.bool
}
